import axios from "axios";

const API = process.env.REACT_APP_API_BASE;
const ADMIN_EMAILS = [
  process.env.REACT_APP_ADMIN,
  process.env.REACT_APP_ARI_ADMIN,
]
  .filter(Boolean)
  .map((email) => email.trim().toLowerCase());

const getTreeData = async () => {
  const response = await axios.get(`${API}/progressbar/get`);
  return {
    persons: Array.isArray(response.data?.persons) ? response.data.persons : [],
    goals: Array.isArray(response.data?.goals) ? response.data.goals : [],
  };
};

const updatePerson = async (person, changes, adminEmail) => {
  const normalizedEmail = String(adminEmail || "").trim().toLowerCase();
  if (!normalizedEmail || !ADMIN_EMAILS.includes(normalizedEmail)) {
    throw new Error("Accesul este disponibil doar administratorilor configurați.");
  }
  if (!person?.documentId) throw new Error("Persoana nu are un identificator valid.");

  const response = await axios.put(
    `${API}/organization/tree/${encodeURIComponent(person.documentId)}`,
    { changes },
    {
      headers: {
        ...(process.env.REACT_APP_TOKEN
          ? { Authorization: `Basic ${process.env.REACT_APP_TOKEN}` }
          : {}),
        "x-admin-email": normalizedEmail,
      },
    }
  );

  return response.data?.data || response.data;
};

const organizationService = {
  getTreeData,
  updatePerson,
};

export default organizationService;
